<template>
  <div class="-mr-6 flex overflow-x-scroll md:flex-wrap md:overflow-x-visible">
    <TravelDatesFilter
      v-if="['hotel'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      @apply="applyFilters"
      @update="updateTotals"
    />
    <GuestsFilter
      v-if="['hotel'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      @apply="applyFilters"
      @update="updateTotals"
    />
    <PriceSlider
      v-if="['hotel'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      :venue-type="venueType"
      :destination="destination"
      @apply="applyFilters"
      @update="updateTotals"
    />
    <PriceCategoriesFilter
      v-if="['restaurant'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      @apply="applyFilters"
      @update="updateTotals"
    />
    <NeighborhoodsFilter
      v-if="['restaurant', 'attraction', 'hotel'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      @apply="applyFilters"
      @update="updateTotals"
    />
    <CategoriesFilter
      v-if="['restaurant', 'attraction'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      :name="venueType.permalink === 'restaurant' ? 'Cuisine' : 'Attraction type'"
      :show-search="venueType.permalink === 'restaurant'"
      @apply="applyFilters"
      @update="updateTotals"
    />
    <AmenitiesFilter
      v-if="['hotel'].includes(venueType.permalink)"
      class="mb-2"
      :filters="localFilters"
      @apply="applyFilters"
      @update="updateTotals"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import NeighborhoodsFilter from '~/components/venues/filters/NeighborhoodsFilter'
import CategoriesFilter from '~/components/venues/filters/CategoriesFilter'
import TravelDatesFilter from '~/components/venues/filters/TravelDatesFilter'
import AmenitiesFilter from '~/components/venues/filters/AmenitiesFilter'
import PriceCategoriesFilter from '~/components/venues/filters/PriceCategoriesFilter'
import PriceSlider from '~/components/venues/filters/PriceSlider'
import GuestsFilter from '~/components/venues/filters/GuestsFilter'
import deepMerge from '~/utils/deep-merge'
import { useVenuesStore } from '~/stores/venues'

export default {
  components: { GuestsFilter, PriceSlider, PriceCategoriesFilter, AmenitiesFilter, TravelDatesFilter, CategoriesFilter, NeighborhoodsFilter },

  props: {
    venueType: { type: Object, required: true },
    destination: { type: Object, required: true },
  },

  data: () => ({
    localFilters: {},
  }),

  computed: {
    ...mapState(useVenuesStore, ['filters']),
  },

  watch: {
    filters: {
      deep: true,
      handler () {
        this.localFilters = deepMerge({}, this.filters)
      },
    },
  },

  beforeMount () {
    this.localFilters = deepMerge({}, this.filters)
  },

  methods: {
    ...mapActions(useVenuesStore, ['loadTotals', 'updateFilters']),

    applyFilters (filters) {
      this.localFilters = deepMerge({}, this.localFilters, filters)
      this.updateFilters(deepMerge({}, this.localFilters))
    },

    updateTotals (filters) {
      this.loadTotals(deepMerge({ destinationId: this.destination.id }, this.localFilters, filters))
    },
  },
}
</script>
